import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { IFormStore } from '../interface';
import { CollateralPropertyModel } from '../model';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: CollateralPropertyModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class CollateralPropertyStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<CollateralPropertyModel>((_, data) => {
    return {
      state: 'valid',
      data: CollateralPropertyModel.fromJson(data),
    };
  });
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));

  constructor() {
    super(initialState);
  }
}
